module.exports = cast.framework;